import React from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import { Row } from "react-flexbox-grid/lib/index";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  CardActions,
  Button,
  LinearProgress
} from "@material-ui/core";
import Refresh from "@material-ui/icons/Refresh";

import FilesListTable from "./FilesListTable";

const FilesListCard = props => (
  <Card>
    <CardHeader title="Select files to annotate" />
    <CardContent>
      <Typography component="p" style={{ marginBottom: 10 }}>
        If you can&#39;t annotate the file and are sure the data can&#39;t be
        used, you can remove it from this list by entering a comment and
        clicking &#39;remove file&#39;. However, if there&#39;s any chance the
        data could be salvaged or it looks like there could be a portal or
        instrument error, please let IT know so we can work on resolving it.
      </Typography>
      {props.soloFilesFetching && <LinearProgress />}
      <Row center="xs">
        <ContainerDimensions>
          <FilesListTable {...props} />
        </ContainerDimensions>
      </Row>
    </CardContent>
    <CardActions>
      <Button
        variant="text"
        onClick={props.onFilesRefreshClick}
        color="secondary"
        style={{ paddingTop: "10px", marginLeft: "auto" }}
      >
        Refresh
        <Refresh />
      </Button>
    </CardActions>
  </Card>
);

FilesListCard.propTypes = {
  onFilesRefreshClick: PropTypes.func.isRequired,
  soloFilesFetching: PropTypes.bool
};
FilesListCard.defaultProps = {
  soloFilesFetching: false
};

export default FilesListCard;
